import clsx from 'clsx';
import React, { FormEvent, MouseEvent, useCallback } from 'react';
import useTrackSearch from '../../../hooks/tracking/useTrackSearch';
import useHistory from '../../../Router/useHistory';
import { Search as StyledSearch, SearchBar } from '../../../styled/Header/Main/wrappers';
import InputSearch, { IQuerySuggestion } from '../../../styled/InputSearch';
import useSearch from './useSearch';

const easterEggMap = ['ett jobb', 'jobb'];
const queryLocationMap = {
  jobb: '/om-mio/jobba-pa-mio',
  'ett jobb': '/om-mio/jobba-pa-mio',
};

interface ISearch {
  isHidden?: boolean;
  searchOpenMobile?: boolean;
}

const Search = ({ isHidden, searchOpenMobile }: ISearch) => {
  const { query, onQueryChange, inputRef, reset, suggestions } = useSearch();
  const { push } = useHistory();
  const onSearch = useTrackSearch();

  const clickSuggestion = useCallback(
    (e: MouseEvent<HTMLAnchorElement>, suggestion: IQuerySuggestion) => {
      e.preventDefault();
      reset();
      onSearch(suggestion.title);
      push({
        pathname: suggestion.url,
        search: undefined,
      });
    },
    [],
  );

  const submit = useCallback(
    (e: FormEvent) => {
      e.preventDefault();
      reset();

      if (easterEggMap.includes(query.toLowerCase())) {
        push({
          pathname: queryLocationMap[query.toLowerCase() as keyof typeof queryLocationMap],
        });
      } else if (query) {
        onSearch(query);
        push({
          pathname: '/sok',
          search: `?q=${query}`,
        });
      }

      if (inputRef.current) {
        inputRef.current.blur();
      }
    },
    [query],
  );

  return (
    <StyledSearch className={clsx(isHidden && 'is-hidden', searchOpenMobile && 'is-overlay')}>
      <SearchBar as="form" onSubmit={submit}>
        <InputSearch
          onBlur={reset}
          onChange={onQueryChange}
          onSuggestionClick={clickSuggestion}
          placeholder="Vad letar du efter?"
          inputRef={inputRef}
          title="Sök i hela sortimentet"
          value={query}
          querySuggestion={suggestions}
        />
      </SearchBar>
    </StyledSearch>
  );
};

export default Search;
